/********************************************************************************/

import * as javascript from "@radically-straightforward/javascript/static/index.mjs";
import * as utilities from "@radically-straightforward/utilities";


/********************************************************************************/

javascript?.execute?.functions?.set?.("eqaardgidttjkb", async function() {
  window.setTimeout(() => {
    this.remove();
  }, 5 * 1000);
}
);

/********************************************************************************/

javascript?.execute?.functions?.set?.("zcevctffnxwrm", async function() {
  this.onclick = () => {
    this.select();
  };
}
);

/********************************************************************************/

javascript?.execute?.functions?.set?.("ebzlonmvwznnjw", async function($$0) {
  const popover = javascript.popover({ element: this, trigger: "none" });
  this.onclick = async () => {
    await navigator.clipboard.writeText($$0);
    popover.showPopover();
    await utilities.sleep(1000);
    popover.hidePopover();
  };
}
);

/********************************************************************************/

javascript?.execute?.functions?.set?.("hgtjbswzncxcvl", async function() {
  this.onvalidate = () => {
    try {
      new URL(this.value);
    } catch {
      throw new javascript.ValidationError("Invalid URL.");
    }
  };
}
);

/********************************************************************************/

javascript?.execute?.functions?.set?.("dsfhkvmvlppeat", async function($$0, $$1) {
  this.onvalidate = () => {
    if (this.value !== $$0) throw new javascript.ValidationError($$1);
  };
}
);

